export const RETARGET_EMAIL_SEND_TIME_OPTIMIZATION = 'RETARGET_EMAIL_SEND_TIME_OPTIMIZATION';

export default {
  name: RETARGET_EMAIL_SEND_TIME_OPTIMIZATION,
  rollOut: 0,
};
